import Vue from "vue";
import Router from "vue-router";
import cognito from "@/cognito";

Vue.use(Router);
Vue.use(BootstrapVue); // add
Vue.config.productionTip = false;

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { SET_AUTH } from "@/store/mutations.type";
import store from "@/store";
import axios from "axios";
import { API_BASE_URL } from "@/common/config";

const requireAuth = (to, from, next) => {
  //console.log("認証状況チェック：requireAuth");
  cognito
    .checkAuthenticated()
    .then((result) => {
      if (result != null) {
        //console.log("Cognito認証チェックOK");
        //console.debug(JSON.stringify(result));
        store.commit(SET_AUTH, result);
        // アクセスログの記録
        createAccessLog();
        next();
      } else {
        //console.log("Cognito認証情報なし。");
        //ログイン画面に遷移
        goTOLogin(to, next);
      }
    })
    .catch(() => {
      //console.error("Cognito認証チェックエラー。");
      //console.debug(to.fullPath);
      //リダイレクト先があれば、該当のパスをセッションストレージに格納する
      sessionStorage.setItem("redirect_path", to.fullPath);
      //ログイン画面に遷移
      goTOLogin(to, next);
    });
};

const createAccessLog = () => {
  let api_url = API_BASE_URL + "access-logs";
  axios
    .post(api_url, "", {
      headers: {
        "Content-Type": "application/json",
        Authorization: store.getters.currentUser.idToken.jwtToken
      }
    })
    .then((result) => {
      store.state.logger.debug("result:\n" + JSON.stringify(result));
    })
    .catch((error) => {
      // 例外の場合はコンソールログのみ出力
      store.state.logger.error("createAccessLog API(POST) error");
      store.state.logger.error(JSON.stringify(error));
    });
};

const goTOLogin = (to, next) => {
  let authType = process.env.VUE_APP_AUTH_TYPE;
  if (authType === "okta" || authType === "entraid") {
    cognito.federatedSignIn();
  } else if (authType === "cognito") {
    next({ path: "/login", query: { redirect: to.fullPath } });
  }
};

export default new Router({
  mode: "history",
  routes: [
    {
      name: "user-registration",
      path: "/user-registration",
      component: () => import("@/views/LECO_UserRegistration")
    },
    {
      name: "user-confirmation",
      path: "/user-confirmation",
      component: () => import("@/views/LECO_UserRegistConfirmation")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/LECO_Login")
    },
    //Okta認証に伴い追加
    {
      name: "sso-redirect",
      path: "/sso-redirect",
      component: () => import("@/views/LECO_SsoRedirect")
    },
    {
      name: "web-meeting-rec-watch-redirect",
      path: "/web-meeting-rec-watch/:id(\\d+)",
      component: () => import("@/views/LECO_WebMeetingRecWatchRedirect"),
      beforeEnter: requireAuth
    },
    {
      name: "password-reset",
      path: "/password-reset",
      component: () => import("@/views/LECO_PasswordReset")
    },
    {
      name: "email-confirm",
      path: "/user/setting/confirm",
      component: () => import("@/views/LECO_EmailConfirm")
    },
    {
      name: "top",
      path: "/",
      component: () => import("@/views/LECO_TrainingScheduleAll"),
      beforeEnter: requireAuth
    },
    {
      name: "training-plan-registration",
      path: "/training-plan-registration/",
      component: () => import("@/views/LECO_TrainingPlanRegistration"),
      beforeEnter: requireAuth
    },
    {
      name: "training-plan-update",
      path: "/training-plan-update/:id(\\d+)",
      component: () => import("@/views/LECO_TrainingPlanUpdate"),
      beforeEnter: requireAuth
    },
    {
      name: "questionnaire-answer",
      path: "/questionnaire-answer/:id(\\d+)",
      component: () => import("@/views/LECO_TrainingQuestionnaireAnswer"),
      beforeEnter: requireAuth
    },
    {
      name: "questionnaire-answer-result",
      path: "/questionnaire-answer-result/:id(\\d+)",
      component: () => import("@/views/LECO_TrainingQuestionnaireAnswerResult"),
      beforeEnter: requireAuth
    },
    {
      name: "star-list",
      path: "/star-list/",
      component: () => import("@/views/LECO_StarList"),
      beforeEnter: requireAuth
    },
    {
      name: "wish-list",
      path: "/wish-list/",
      component: () => import("@/views/LECO_WishList"),
      beforeEnter: requireAuth
    },
    {
      name: "wish-list-detail",
      path: "/wish-list-detail/:id(\\d+)",
      component: () => import("@/views/LECO_WishListDetail"),
      beforeEnter: requireAuth
    },
    {
      name: "training-schedule-all",
      path: "/training-schedule-all/",
      component: () => import("@/views/LECO_TrainingScheduleAll"),
      beforeEnter: requireAuth
    },
    {
      name: "access-logs",
      path: "/access-logs/",
      component: () => import("@/views/LECO_AccessLogList"),
      beforeEnter: requireAuth
    },
    {
      name: "system-error400",
      path: "/system-error400/",
      component: () => import("@/views/LECO_SystemError400"),
      beforeEnter: requireAuth
    },
    {
      name: "system-error404",
      path: "/system-error404/",
      component: () => import("@/views/LECO_SystemError404"),
      beforeEnter: requireAuth
    },
    {
      name: "user-delete",
      path: "/user-delete/",
      component: () => import("@/views/LECO_UserDelete"),
      beforeEnter: requireAuth
    },
    {
      name: "system-error500",
      path: "/system-error500/",
      component: () => import("@/views/LECO_SystemError500"),
      beforeEnter: requireAuth
    },
    {
      name: "not found",
      path: "*",
      component: () => import("@/views/LECO_SystemError404"),
      beforeEnter: requireAuth
    }
  ]
});
